import StoreSelection from './StoreSelection.container';

export default StoreSelection;
